/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    import Predicate = breeze.Predicate;

    export class TagService extends services.DataService<Wars.Domain.Model.Tag> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getTagsLike(tagType: Wars.Domain.Model.Codes.Enums.TagType): angular.IPromise<Wars.Domain.Model.Tag[]> {
            let query;
            if (tagType === Wars.Domain.Model.Codes.Enums.TagType.Condition) {
                query = this.breezeModule.EntityQuery
                    .from("Tags")
                    .where("condition_id", "!=", null);
                return this.executeQuery(query);
            }
            if (tagType === Wars.Domain.Model.Codes.Enums.TagType.Calculation) {
                query = this.breezeModule.EntityQuery
                    .from("Tags")
                    .where("calculation_id", "!=", null);
                return this.executeQuery(query);
            }
            if (tagType === Wars.Domain.Model.Codes.Enums.TagType.Query) {
                query = this.breezeModule.EntityQuery
                    .from("Tags")
                    .where("queryConfiguration_id", "!=", null);
                return this.executeQuery(query);
            }

            return null;
        }

        public createTag(): Wars.Domain.Model.Tag{
            return this.createNewEntity<Wars.Domain.Model.Tag>("Tag");
        }

    }
}

warsApp.registerService('TagService', ['breeze', '$q']);